import { render, staticRenderFns } from "./Swdynamics.vue?vue&type=template&id=ffe4d094&scoped=true"
import script from "./Swdynamics.vue?vue&type=script&lang=js"
export * from "./Swdynamics.vue?vue&type=script&lang=js"
import style0 from "./Swdynamics.vue?vue&type=style&index=0&id=ffe4d094&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe4d094",
  null
  
)

export default component.exports